import React, { memo, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { useRecoilState } from 'recoil';

import { IAsset, assetTabListState, assetTabIndexState } from './store/AssetsStore';
import Header from '../../../Public/Header/Header';
import ContentsWrapper from '../../../Public/Wrapper/ContentsWrapper';
import AssetList from "./AssetList";
import AssetDetail from "./AssetDetail";

const useStyles = makeStyles(() => ({
  margin: {
    margin: "0 0 0 10px",
  },
}));


const Assets = () => {

  const muiClasses = useStyles();

  const [tabList, setTabList] = useRecoilState(assetTabListState);
  const [tabIndex, setTabIndex] = useRecoilState(assetTabIndexState);

  //init Tab list when init
  useEffect(() => {
    setTabList([]);
    setTabIndex(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {

    if (tabList.length < tabIndex - 1) {
      setTabIndex(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabList, tabIndex]);



  const removeTab = (removeItem: IAsset) => {
    //setTabIndex(0);
    const filtered = tabList.filter((i) => {
      return i.VehicleId !== removeItem.VehicleId;
    });

    setTabList(filtered);

  };

  return (
    <ContentsWrapper header={<Header title="Vehicles" />}>
      <div className="row no-gutters">
        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            <Tabs forceRenderTabPanel={true} selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
              <TabList>
                <Tab height="38" > Vehicles</Tab>
                <Tab height="38" >Add </Tab>
                {
                  tabList?.map((item: IAsset) =>
                    <Tab key={item.VehicleId} height="38">
                      {item.VehiclePlate}
                      <IconButton aria-label="delete" className={muiClasses.margin} size="small" onClick={() => removeTab(item)}>
                        <CancelIcon fontSize="inherit" />
                      </IconButton>
                    </Tab>
                  )
                }
              </TabList>

              <TabPanel>
                <AssetList />
              </TabPanel>
              <TabPanel>
                <AssetDetail />
              </TabPanel>
              {
                tabList?.map((item) => (
                  <TabPanel key={item.VehicleId}
                    headers={item.VehiclePlate}>
                    <AssetDetail
                      item={item}
                    />
                  </TabPanel>
                ))
              }
            </Tabs>
          </div>
        </div>
      </div>
    </ContentsWrapper>
  );
};

export default memo(Assets);